module.exports = __webpack_public_path__ + "img/電気回路_5_10_2.f99c79c4.png";